import styled from '@emotion/styled';
import {Dialog, Slide} from '@mui/material';
import {TransitionProps} from '@mui/material/transitions';
import React, {Ref} from 'react';

const Transition = React.forwardRef(
	(
		props: TransitionProps & {
			children: React.ReactElement;
		},
		ref: Ref<unknown>
	) => {
		return <Slide direction="left" ref={ref} {...props} />;
	}
);

const SideDialog = styled(Dialog)(() => ({
	'& .MuiDialog-container': {
		alignItems: 'right',
		margin: 0,
		padding: 0,
		justifyContent: 'right',
		width: '100%',
	},
	'& .MuiPaper-root': {
		margin: 0,
		padding: 0,
		width: '70%',
		maxWidth: '250px',
		height: '100vh',
		maxHeight: '100vh',
		borderRadius: '8px 0px 0px 8px',
	},
	'& .MuiDialogContent-root': {
		paddingBottom: '4px',
	},
}));

export default SideDialog;
export {Transition};
